interface UserData {
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  message?: string;
}
    
interface FormValidation {
  postData: UserData;
}

const contactUsValidateFirstName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.firstName || postData.firstName.trim() === '') {
    errors.push('First name cannot be empty');
    isValid = false;
  } else if (postData.firstName.length < 2) {
    errors.push('First name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.firstName)) {
    errors.push('First name must contain only letters and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};

const contactUsValidateLastName = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;

  if (!postData.lastName || postData.lastName.trim() === '') {
    errors.push('Last name cannot be empty');
    isValid = false;
  } else if (postData.lastName.length < 2) {
    errors.push('Last name must be at least 2 letters');
    isValid = true;
  } else if (!/^[a-zA-Z]+$/.test(postData.lastName)) {
    errors.push('Last name must contain only letters and no whitespaces');
    isValid = true;
  }
  return { isValid, errors };
};

const contactUsValidateEmailAddress = ({ postData }: FormValidation) => {
  const errors: string[] = [];
  let isValid = false;
  const emailRegex = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;

  if (!postData.emailAddress || postData.emailAddress.trim() === '') {
    errors.push('Email address cannot be empty');
    isValid = false;
  } else if (!emailRegex.test(postData.emailAddress)) {
    errors.push('Invalid email address');
    isValid = true;
  }
  return { isValid, errors };
};

const contactUsValidateMessage =({postData}: FormValidation) => {
    const errors: string[] = [];
    let isValid = false;

    if (!postData.message || postData.message.trim() === '') {
        isValid = false;
    }else if(!postData){
        errors.push('Message must be at least 4 characters');
        isValid = true;
    }

    return { isValid, errors };
};

export {
    contactUsValidateFirstName,
    contactUsValidateLastName,
    contactUsValidateEmailAddress,
    contactUsValidateMessage,
}